var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfCircleShade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245,
    height: 246,
    viewBox: "0 0 245 246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13873",
    "data-name": "Rectangle 13873",
    width: 245,
    height: 246,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105855",
    "data-name": "Path 105855",
    d: "M528.1,165.546c82.543,0,149.456,66.625,149.456,148.811q0,1.968-.051,3.924h0V497.72A236.747,236.747,0,0,1,528.1,550.482c-130.975,0-237.151-105.718-237.151-236.128,0-104.641,1.211-209.592,1.211-314.364,22.2,0,57.381,23.446,57.381,56.373v102.6A237.013,237.013,0,0,1,528.1,78.225c130.975,0,237.151,105.718,237.151,236.128a234.552,234.552,0,0,1-55.711,152.032l-.417-131.87c-.143-44.751-1.013-73.187-28.658-116.463A180.492,180.492,0,0,0,528.1,134.683c-99.659,0-180.448,80.44-180.448,179.67S428.442,494.02,528.1,494.02a180.177,180.177,0,0,0,92.211-25.205V431.472A149.223,149.223,0,0,1,528.1,463.164c-82.543,0-149.456-66.625-149.456-148.811S445.558,165.541,528.1,165.541Zm0,57.8c50.484,0,91.409,40.748,91.409,91.014s-40.924,91.014-91.409,91.014-91.408-40.748-91.408-91.014S477.615,223.343,528.1,223.343Z",
    transform: "translate(-528.1 -72.887)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.09
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircleShade);
export default __webpack_public_path__ + "static/media/half-circle-shade.c98b70f0961e47c3963da803f91dc484.svg";
export { ForwardRef as ReactComponent };